module.exports = __webpack_public_path__ + "static/media/img12.8b997561.jpg";